<template>
  <div class="container mx-auto lg:py-16 py-10 px-3 ">
    <div class="flex flex-col gap-5 items-center">
      <div class="text-base text-primary font-primary uppercase font-semibold">
        Workflow
      </div>
      <div class="lg:text-5xl text-2xl font-bold font-primary text-center">
        Gill Brother Working Process
      </div>
      <div class="grid lg:grid-cols-3  grid-cols-1 gap-10 py-5 w-full">
        <div class="flex items-center flex-col gap-5 " v-for="item, index in img_data" :key="index">
          <div
            class="bg-[#FF7003] bg-opacity-25 p-3 rounded-full w-[60px] h-[60px] flex items-center justify-center animate-bounce ease-in-out">
            <img :src="item.image" width="50" height="50" />
          </div>
          <div class="text-2xl font-semibold font-primary text-center">{{ item.heading }}</div>
          <div class="text-base text-center text-grey w-full">{{ item.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const img_data = [
  {
    image: require("../../assets/v-1.1/make-appointment.svg"),
    heading: "Make an Appointment",
    desc: "Appointment At Gill Brother Plumbing, we understand the importance of timely service. Our streamlined process begins with you making an appointment.",
  },
  {
    image: require("../../assets/v-1.1/arrive-location.svg"),
    heading: "Arrive at your location",
    desc: "Once the appointment is set, our skilled plumbers will arrive at your location on time, equipped with the necessary tools and expertise to handle any plumbing issue. ",
  },
  {
    image: require("../../assets/v-1.1/solve-problem.svg"),
    heading: "Solving Your Problem",
    desc: "With years of experience and industry knowledge, our skilled and experienced plumbers are well-equipped to tackle a wide range of plumbing challenges.",
  },
];

</script>